import React, { useEffect, useState } from 'react'
import AddEditForm from '../../../sharedComponents/AddEditForm'
import { PencilIcon, TrashIcon } from '@heroicons/react/24/solid'
import Modal from 'react-modal';
import DeleteConfirm from '../../../sharedComponents/DeleteConfirm';
import { toast } from 'react-toastify';
import useManageCategory from './useManageSku';
import useManageSku from './useManageSku';
import TestInvoice from '../order/TestInvoice';

const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      height: 'auto',
      width: '500px',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };

const items = [
  {
    title: 'SKU Code',
    name: 'skuCode',
    type: 'text',
  },
  {
    title: 'Product Name',
    name: 'productName',
    type: 'text',
  },
  {
    title: 'Product Group',
    name: 'productGroup',
    type: 'text',
  },
  {
    title: 'Unit Price',
    name: 'unitPrice',
    type: 'text',
  },
];

const initialValue = {
  productName: '',
  unitPrice: '',
  skuCode: '',
}
const SkuSetting = () => {

  const [mode, setMode] = useState('register')
  const [modalTitle, setModalTitle] = useState('Register Category Information')

  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const [sku, setSku] = useState(initialValue);

  const {
    skus,
    error,
    addSku,
    editSku,
    deleteSku,
    getSkus
  } = useManageSku();

  const handleInputChange = (e) => {
    const {name, value} = e.target;
    setSku({...sku, [name]: value})
  }

  const openForm = async (isEdit,id) => {
    if(isEdit){
      const skuToEdit = skus.find(w => w.id === id);
      if(skuToEdit) {
        setSku(skuToEdit);
        setModalTitle('Update Category Information');
        setMode('edit');
      }

    }else{
      setSku(initialValue)
      setMode('register')
      setModalTitle('Register Category Information')
    }
    setIsFormOpen(true);
  };

  const closeForm = () =>{
    setIsFormOpen(false);
  }

  const openConfirm = async (id) => {
    const skuToDelete = skus.find(w => w.id === id);
    if(skuToDelete) {
      setSku(skuToDelete);
      setIsConfirmOpen(true)
    }
  };

  const closeConfirm = () =>{
    setIsConfirmOpen(false)
  }

  const handleRegisterCategory = async () => {
    try {
        const returnResult = await addSku(sku);
        if (returnResult === true) {
          toast.success('Category registered successfully!');
          closeForm();
        } else {
          toast.error(returnResult);
        }
    } catch (err) {

    }
  };

useEffect(() => {
  toast.error(error);
}, [error]);

const handleUpdateCategory = async () => {
    const response = await editSku(sku.id, sku);
    if(response === true){
      toast.success('Category updated successfully!');
      closeForm();
    }else{
      toast.error(response);
    }
};

const handleDeleteCategory = async () => {
  try {
    await deleteSku(sku.id);
    toast.success('Category deleted successfully!');
    closeConfirm();
  } catch (error) {
    const errorMessage = error.response?.data?.message || "An unexpected error occurred.";
    toast.error(errorMessage);
  }
};

  useEffect(() => {
    getSkus();
  }, []);


  return (
    <div>
      <h2 className='text-5xl'>SKU Setting</h2>
      <Modal
        isOpen={isFormOpen}
        onRequestClose={closeForm}
        style={customStyles}
        ariaHideApp={false}
      >
        <AddEditForm 
          items={items} 
          name={modalTitle} 
          data={sku} 
          mode={mode}
          closeForm={closeForm}
          handleInputChange={handleInputChange}
          handleRegister={handleRegisterCategory}
          handleUpdate={handleUpdateCategory}
          stateValue={sku}
        />
      </Modal>
      <Modal
        isOpen={isConfirmOpen}
        onRequestClose={closeConfirm}
        style={customStyles}
        ariaHideApp={false}
      >
        <DeleteConfirm 
          items={items} 
          data={sku} 
          closeConfirm={closeConfirm}
          confirmFunction={handleDeleteCategory}
        />
      </Modal>
      <TestInvoice />
        <div className="px-4 sm:px-6 lg:px-8">
        <div className="mt-8 flow-root">
          <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                <div className='flex justify-end'>
                    <button onClick={()=> openForm(false, null)} className='ml-auto bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded'>
                        Add New SKU
                    </button>
                </div>
              <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
                <table className="min-w-full divide-y divide-gray-300">
                  <thead className="bg-gray-50">
                    <tr>
                      <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                        No
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        SKU Code
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Product Name
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Product Group
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Unit Price
                      </th>
                      <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                        <span className="sr-only">Edit</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {skus.map((sku, index) => {
                      const {skuCode, productName,unitPrice, productGroup , id} = sku
                      return <tr key={id}>
                        <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                          {index + 1}
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-700">{skuCode}</td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-700">{productName}</td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-700">{productGroup}</td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-700">{unitPrice}</td>
                        <td className="relative whitespace-nowrap py-4 pl-3 pr-0 text-right text-sm font-medium ">
                            <div className="flex items-center space-x-3">
                                <PencilIcon onClick={()=> openForm(true,id)} className='cursor-pointer flex items-center w-6 h-6 fill-green-600'/>
                                <TrashIcon onClick={()=> openConfirm(id)} className='cursor-pointer flex items-center w-6 h-6 fill-red-600'/>
                            </div>
                        </td>
                      </tr>
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SkuSetting